var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.258 395.394c6.326-23.131-5.953-70.684-5.953-70.684s-8.906 38.739-22.822 53.057c-11.872 12.213-26.417 20.684-47.277 22.91 17.055-8.284 28.784-25.557 28.784-45.522 0-28.026-23.112-50.746-51.622-50.746s-51.623 22.72-51.623 50.746a49.84 49.84 0 0 0 4.812 21.421c-17.832-14.206-20.636-36.982-20.636-36.982s-19.912 82.67 34.954 121.558c54.865 38.888 162.344 5.462 162.344 5.462S229.41 574.837 115.436 457.05c-98.18-101.466-25.625-235.047-25.625-235.047s-3.133 12.392-3.133 26.777c0 14.385 7.799 25.33 7.799 25.33s23.265-49.039 41.371-68.982c17.136-18.874 38.617-34.182 57.171-47.404 14.282-10.178 26.83-19.12 34.324-27.501C268.62 84.069 243.311 0 243.311 0s46.53 41.02 59.52 93.998c4.952 20.194 1.766 43.171-1.082 63.718-4.624 33.356-8.361 60.309 25.044 58.56 53.982-2.827 7.073-86.053 7.073-86.053s122.452 64.36 113.304 176.922c-9.149 112.562-133.846 138.152-133.846 138.152s32.607-26.772 38.934-49.903z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.d6daaa2c.svg";
export { ForwardRef as ReactComponent };